import { DefaultTheme, ThemeProps } from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getToken } from '@optimus-web/common';

export type States = 'disabled' | 'error' | 'default';

interface ChipProps {
    disabled?: boolean;
    error?: boolean;
}

export type ColorTokens<T extends string> = {
    [state in T]?: ((props: ThemeProps<DefaultTheme>) => string) | string;
};

export const getState = (props: ThemeProps<DefaultTheme> & ChipProps) => {
    const state: States = (() => {
        if (props?.disabled) {
            return 'disabled';
        } else if (props?.error) {
            return 'error';
        }

        return 'default';
    })();

    return { state };
};

export const getBackgroundColor = (props: ThemeProps<DefaultTheme>) => {
    const getBackgroundColorTokens: ColorTokens<States> = {
        disabled: getToken(TokenName.BACKGROUND_DISABLED),
        error: getToken(TokenName.BACKGROUND_ALERT_DANGER_SECONDARY),
        default: getToken(TokenName.BACKGROUND_INTERACTIVE_NEUTRAL_DEFAULT),
    };

    const { state } = getState(props);
    return getBackgroundColorTokens[state];
};

export const getHoverBackgroundColor = (props: ThemeProps<DefaultTheme>) => {
    const getHoverBackgroundColorTokens: ColorTokens<States> = {
        disabled: getToken(TokenName.BACKGROUND_DISABLED),
        error: getToken(TokenName.BACKGROUND_ALERT_DANGER_SECONDARY),
        default: getToken(TokenName.BACKGROUND_INTERACTIVE_NEUTRAL_HOVER),
    };

    const { state } = getState(props);
    return getHoverBackgroundColorTokens[state];
};

export const getActiveBackgroundColor = (props: ThemeProps<DefaultTheme>) => {
    const getActiveBackgroundColorTokens: ColorTokens<States> = {
        disabled: getToken(TokenName.BACKGROUND_DISABLED),
        error: getToken(TokenName.BACKGROUND_ALERT_DANGER_SECONDARY),
        default: getToken(TokenName.BACKGROUND_INTERACTIVE_NEUTRAL_ACTIVE),
    };

    const { state } = getState(props);
    return getActiveBackgroundColorTokens[state];
};

export const getColor = (props: ThemeProps<DefaultTheme>) => {
    const getColorTokens: ColorTokens<States> = {
        disabled: getToken(TokenName.TEXT_DISABLED),
        error: getToken(TokenName.TEXT_ALERT_DANGER),
        default: getToken(TokenName.TEXT_STATIC_PRIMARY),
    };

    const { state } = getState(props);
    return getColorTokens[state];
};

export const getHoverColor = (props: ThemeProps<DefaultTheme>) => {
    const getHoverColorTokens: ColorTokens<States> = {
        disabled: getToken(TokenName.TEXT_DISABLED),
        error: getToken(TokenName.TEXT_ALERT_DANGER),
        default: getToken(TokenName.TEXT_STATIC_PRIMARY),
    };

    const { state } = getState(props);
    return getHoverColorTokens[state];
};

export const getActiveColor = (props: ThemeProps<DefaultTheme>) => {
    const getActiveColorTokens: ColorTokens<States> = {
        disabled: getToken(TokenName.TEXT_DISABLED),
        error: getToken(TokenName.TEXT_ALERT_DANGER),
        default: getToken(TokenName.TEXT_STATIC_PRIMARY),
    };

    const { state } = getState(props);
    return getActiveColorTokens[state];
};
